<template>
  <mds-table class="custom-table">
    <CustomTableHeader :columns="columns" />
    <CustomTableBody
      :table-type="tableType"
      :records="records"
      :actions="actions"
      v-on="$listeners"
    />
  </mds-table>
</template>

<script>
import { MdsTable } from '@mds/data-table'
import CustomTableHeader from './CustomTableHeader.vue'
import CustomTableBody from './CustomTableBody.vue'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/config/i18n'
export default {
  name: 'CustomTable',
  components: {
    MdsTable,
    CustomTableHeader,
    CustomTableBody,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    tableType: {
      type: String,
      default: 'feeds',
      docs: {
        validation: 'One of: `feeds`, `schedules`.',
      },
    },
    columns: {
      tableType: Array,
      default: () => [],
    },
    records: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';

.custom-table {
  margin-top: $mds-space-1-and-a-half-x;
}
</style>
